import { Handshake, ExternalLink } from "lucide-react";
import PageLayout from "../components/site/PageLayout";
import { SectionHeading } from "../components/site/SectionHeading";
import { Reveal } from "../components/site/Reveal";
import { useContent } from "../lib/content";
import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";

const Partners = () => {
  const { content } = useContent();
  return (
    <PageLayout title="Partners">
      <section className="relative pt-16 pb-10 overflow-hidden">
        <div className="ambient" aria-hidden />
        <div className="ambient-grid" aria-hidden />
        <div className="container-tt">
          <SectionHeading eyebrow="Partners" title="The senior centers we serve." description="TechTies partners with senior centers across Orange County. Interested in hosting us at your community? We'd love to talk." />
        </div>
      </section>

      <section className="py-14">
        <div className="container-tt grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="partners-grid">
          {content.locations.map((l, i) => (
            <Reveal key={l.name} delay={i * 0.05}>
              <div className="card-surface card-lift p-8 h-full flex flex-col">
                <div className="flex items-center justify-between">
                  <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-accent/70 border border-sky/15 text-skyDark"><Handshake size={20} /></span>
                  <span className={`text-xs font-medium px-3 py-1 rounded-full border ${l.status === "Planned" ? "bg-sandDeep border-border text-stone/70" : "bg-accent border-sky/20 text-skyDark"}`}>{l.status}</span>
                </div>
                <div className="font-display text-2xl mt-6 text-stone">{l.name}</div>
                <div className="text-sm text-muted-foreground mt-1">{l.address}</div>
                <p className="mt-4 text-stone/80 leading-relaxed flex-1">{l.description}</p>
                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(l.mapQuery || l.name)}`}
                  target="_blank" rel="noreferrer"
                  data-testid={`partner-directions-${i}`}
                  className="group mt-6 inline-flex items-center gap-2 text-skyDark font-medium"
                >
                  Get directions <ExternalLink size={14} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-20 border-t border-border/60 bg-gradient-to-b from-white to-accent/30">
        <div className="container-tt text-center">
          <SectionHeading align="center" eyebrow="Partner with us" title="Bring TechTies to your community." />
          <Button asChild className="mt-8 btn-pill btn-motion btn-sky-fill h-14 px-8 text-white shadow-sky hover:shadow-skyHover border-0">
            <Link to="/contact#partnership" data-testid="partners-cta">Start a partnership</Link>
          </Button>
        </div>
      </section>
    </PageLayout>
  );
};

export default Partners;
